module.exports = __webpack_public_path__ + "assets/media/upgrade.6cba9dec.svg";